import React, { Component } from 'react'

export class Contadores extends Component {

   
    render() {
      

      function contadores(s) {
        const styles1 = (s.caudal_1===null&&s.volumen_1===null ) ? {display: 'none'}:{}; 
        const styles2 = (s.caudal_2===null&&s.volumen_2===null ) ? {display: 'none'}:{};
        return (
          <section className="dashboard-counts section-padding">
          <div className="container-fluid">
            <div className="row">
              
              <div className="col-xl-3 col-md-3 col-6" style={styles1}>
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Caudal 1 L/S</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.caudal_1===null)?'null':(s.caudal_1)}</div>
                  </div>
                </div>
              </div>
             
              <div className="col-xl-3 col-md-3 col-6" style={styles1}>
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Volumen 1 M3</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.volumen_1===null)?'null':(s.volumen_1)}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-3 col-6" style={styles2}>
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Caudal 2 L/S</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.caudal_2===null)?'null':(s.caudal_2)}</div>
                  </div>
                </div>
              </div>
             
              <div className="col-xl-3 col-md-3 col-6" style={styles2}>
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Volumen 2 M3</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.volumen_2===null)?'null':(s.volumen_2)}</div>
                  </div>
                </div>
              </div>
              
              <div className="col-xl-3 col-md-3 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Fecha y Hora</strong><span>Última Lectura</span>
                    <div className="count-number">{s.fechalec}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-3 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Temperatura Eagle C°</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.temp_equipo===null)?'null':(s.temp_equipo)}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-3 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Batería V</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.bateria===null)?'null':(s.bateria)}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-3 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Nivel de Señal dBm</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.senal===null)?'null':(-1*s.senal)}</div>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </section>
      )
        
      }

      return contadores(this.props.lecturas);
        
    }
}

export default Contadores
